import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=afa0ee66&scoped=true"
import script from "./ModalTemplate.vue?vue&type=script&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&lang=js"
import style0 from "./ModalTemplate.vue?vue&type=style&index=0&id=afa0ee66&prod&scoped=true&lang=css"
import style1 from "./ModalTemplate.vue?vue&type=style&index=1&id=afa0ee66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa0ee66",
  null
  
)

export default component.exports